import { useEffect, useState } from 'react';

export function useImageWithFallback(imageUrl?: string, fallbackUrl?: string) {
  const [src, setSrc] = useState(imageUrl);

  useEffect(() => {
    if (!fallbackUrl) {
      return;
    }

    if (!imageUrl) {
      setSrc(fallbackUrl);
      return;
    }

    let isMounted = true;
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      if (isMounted) {
        setSrc(imageUrl);
      }
    };

    img.onerror = () => {
      if (isMounted) {
        setSrc(fallbackUrl);
      }
    };

    return () => {
      isMounted = false;
    };
  }, [imageUrl, fallbackUrl]);

  return src;
}
